import * as Yup from 'yup';
import { useFormik } from 'formik';

import { requiredMsg } from 'lib/constants/messages';

const LicenseSchema = Yup.object().shape({
  license_id: Yup.number().required(requiredMsg('License type')),
  issuer_id: Yup.number().required(requiredMsg('License issuer')),
  license_number: Yup.string().required(requiredMsg('License number')),
  expired_on: Yup.date().required(requiredMsg('License expiration date'))
});

export default function useLicenseFormik(onSubmit = () => {}) {
  const formik = useFormik({
    initialValues: {
      license_id: null,
      issuer_id: null,
      license_number: '',
      expired_on: ''
    },
    enableReinitialize: true,
    validationSchema: LicenseSchema,
    onSubmit
  });

  return formik;
}
